// The one shape language for everything that sits in the conversation column.
//
// Platinum's chrome already speaks it: the header's customer and job selects
// are pills, the active nav item is a 6px tile, and the composer at the foot of
// the column is a card with 18px top corners. The message list was the odd one
// out — square bubbles, square tool cards, a 3px rail down the assistant's
// text (Adam, 10 Sep). These tokens bring it into the same family:
//
//   - CARD_RADIUS  every box in the list: the user's bubble, the reasoning
//                  card, a tool chain, an ask-user card, a script or code block,
//                  an artifact preview. 12px sits inside the composer's 18px
//                  the way a nested corner should — smaller than the frame.
//   - PILL_RADIUS  a single-line control, the header pills' shape.
//   - HAIRLINE     the composer's own edge, so every card and the composer
//                  share one line weight and one navy-tinted grey.
//
// One import, one value: a component that needs a radius or an edge takes it
// from here rather than minting its own.
//
// The nesting rule (Adam, 12 Sep: "all message UI uses the same radius and
// ratios"): each level in halves. The composer frame is 18px; a card in the
// list is 12px; a box one level inside a card (a code block inside a tool
// chain, a described option inside an ask-user card, a code or CSV glimpse
// inside an artifact card, a chip) is 6px. Strips and panes that touch a
// card's edge take no radius of their own and are clipped by the card.
// Single-line controls are pills at every level.
export const COMPOSER_RADIUS_PX = 18
export const COMPOSER_RADIUS = `${COMPOSER_RADIUS_PX}px`
export const CARD_RADIUS_PX = 12
export const CARD_RADIUS = `${CARD_RADIUS_PX}px`
/** One level inside a card: nested blocks, previews, chips. */
export const INNER_RADIUS_PX = 6
export const INNER_RADIUS = `${INNER_RADIUS_PX}px`
export const PILL_RADIUS = '999px'
export const HAIRLINE_COLOR = 'rgba(38,55,87,0.10)'
export const HAIRLINE = `1px solid ${HAIRLINE_COLOR}`
/** The border a hovered card takes: the same grey, twice as present. */
export const HAIRLINE_HOVER_COLOR = 'rgba(38,55,87,0.22)'

/** A card in the conversation column. Spread it first, then add layout. */
export const CARD_SX = {
  backgroundColor: 'background.paper',
  border: HAIRLINE,
  borderRadius: CARD_RADIUS,
  overflow: 'hidden',
} as const
